module.exports = __webpack_public_path__ + "static/media/swift.74ba2b9c.svg";